(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-backup"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
      const wrappers = document.querySelectorAll('.product-description-wrapper');

      wrappers.forEach((wrapper) => {
        const content = wrapper.querySelector('.product-description-content');
        const toggleBtn = wrapper.querySelector('.product-description-toggle');

        if (!content || !toggleBtn) return;

        // Check if content is actually truncated
        const isTruncated = content.scrollHeight > content.clientHeight;
        if (!isTruncated) {
          toggleBtn.style.display = 'none';
          return;
        }

        // Unified toggle function
        function toggleDescription() {
          const isExpanded = content.classList.toggle('expanded');
          toggleBtn.setAttribute('aria-expanded', isExpanded);
          toggleBtn.querySelector('.toggle-text').textContent = isExpanded ? '... see less' : 'see more';
          toggleBtn.style.display = isExpanded ? 'none' : 'block';
        }

        // Click on the content toggles
        content.addEventListener('click', function (e) {
          // Prevent interference if clicking on interactive elements (e.g., links, buttons)
          if (e.target.closest('a, button, input, textarea, [contenteditable]')) return;
          toggleDescription();
        });

        // Click on the toggle button also toggles
        toggleBtn.addEventListener('click', toggleDescription);
      });
    });

    // Mobile Media Gallery Interaction
    document.addEventListener('DOMContentLoaded', function () {
      const mobileGalleries = document.querySelectorAll('.product__media-gallery--mobile-only');

      mobileGalleries.forEach((gallery) => {
        const slider = gallery.querySelector('.product__media-slider-mobile');
        const dotsContainer = gallery.querySelector('.product__media-dots');
        const dots = gallery.querySelectorAll('.product__media-dot');
        const images = gallery.querySelectorAll('.product__media-image-mobile');
        const modal = gallery.querySelector('.product__media-modal');
        const modalImage = gallery.querySelector('.product__media-modal-image');
        const modalThumbs = gallery.querySelectorAll('.product__media-modal-thumb');
        const closeModalBtns = gallery.querySelectorAll('[data-modal-close]');

        // Open modal on image click
        images.forEach((img, index) => {
          img.addEventListener('click', () => {
            modalImage.src = img.src;
            modalImage.alt = img.alt;
            // Update active thumb
            modalThumbs.forEach((thumb, i) => {
              if (i === index) {
                thumb.classList.add('is-active');
                thumb.style.border = '14px solid #FFBD00';
                thumb.style.opacity = '1';
                thumb.style.borderRadius = '14px';
              } else {
                thumb.classList.remove('is-active');
                thumb.style.border = 'none';
                thumb.style.opacity = '0.5';
              }
            });
            modal.classList.add('is-open');
            document.body.style.overflow = 'hidden';
          });
        });

        // Close modal
        closeModalBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
          });
        });

        // Thumb click in modal
        modalThumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', () => {
            const mainImage = images[index];
            if (mainImage) {
              modalImage.src = mainImage.src;
              modalImage.alt = mainImage.alt;
            }
            modalThumbs.forEach((t, i) => {
              if (i === index) {
                t.classList.add('is-active');
                t.style.border = '14px solid #FFBD00';
                t.style.opacity = '1';
                t.style.borderRadius = '14px';
              } else {
                t.classList.remove('is-active');
                t.style.border = 'none';
                t.style.opacity = '0.5';
              }
            });
          });
        });

        // Dot navigation (optional: sync with scroll)
        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            // Update active dot
            dots.forEach((d) => d.classList.remove('is-active'));
            dot.classList.add('is-active');

            // Scroll to image
            const targetImage = images[index];
            if (targetImage) {
              targetImage.scrollIntoView({ behavior: 'smooth', inline: 'center' });
            }
          });
        });

        // Optional: Auto-update dots on scroll
        let isScrolling;
        slider.addEventListener('scroll', () => {
          clearTimeout(isScrolling);
          isScrolling = setTimeout(() => {
            const scrollLeft = slider.scrollLeft;
            const itemWidth = images[0].getBoundingClientRect().width + 9;
            const activeIndex = Math.round(scrollLeft / itemWidth);
            dots.forEach((dot, i) => {
              dot.classList.toggle('is-active', i === activeIndex);
            });
          }, 100);
        });
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
      const wrappers = document.querySelectorAll('.product-description-wrapper');

      wrappers.forEach((wrapper) => {
        const content = wrapper.querySelector('.product-description-content');
        const toggleBtn = wrapper.querySelector('.product-description-toggle');

        if (!content || !toggleBtn) return;

        // Check if content is actually truncated
        const isTruncated = content.scrollHeight > content.clientHeight;
        if (!isTruncated) {
          toggleBtn.style.display = 'none';
          return;
        }

        // Unified toggle function
        function toggleDescription() {
          const isExpanded = content.classList.toggle('expanded');
          toggleBtn.setAttribute('aria-expanded', isExpanded);
          toggleBtn.querySelector('.toggle-text').textContent = isExpanded ? '... see less' : 'see more';
          toggleBtn.style.display = isExpanded ? 'none' : 'block';
        }

        // Click on the content toggles
        content.addEventListener('click', function (e) {
          // Prevent interference if clicking on interactive elements (e.g., links, buttons)
          if (e.target.closest('a, button, input, textarea, [contenteditable]')) return;
          toggleDescription();
        });

        // Click on the toggle button also toggles
        toggleBtn.addEventListener('click', toggleDescription);
      });
    });

    // Mobile Media Gallery Interaction
    document.addEventListener('DOMContentLoaded', function () {
      const mobileGalleries = document.querySelectorAll('.product__media-gallery--mobile-only');

      mobileGalleries.forEach((gallery) => {
        const slider = gallery.querySelector('.product__media-slider-mobile');
        const dotsContainer = gallery.querySelector('.product__media-dots');
        const dots = gallery.querySelectorAll('.product__media-dot');
        const images = gallery.querySelectorAll('.product__media-image-mobile');
        const modal = gallery.querySelector('.product__media-modal');
        const modalImage = gallery.querySelector('.product__media-modal-image');
        const modalThumbs = gallery.querySelectorAll('.product__media-modal-thumb');
        const closeModalBtns = gallery.querySelectorAll('[data-modal-close]');

        // Open modal on image click
        images.forEach((img, index) => {
          img.addEventListener('click', () => {
            modalImage.src = img.src;
            modalImage.alt = img.alt;
            // Update active thumb
            modalThumbs.forEach((thumb, i) => {
              if (i === index) {
                thumb.classList.add('is-active');
                thumb.style.border = '14px solid #FFBD00';
                thumb.style.opacity = '1';
                thumb.style.borderRadius = '14px';
              } else {
                thumb.classList.remove('is-active');
                thumb.style.border = 'none';
                thumb.style.opacity = '0.5';
              }
            });
            modal.classList.add('is-open');
            document.body.style.overflow = 'hidden';
          });
        });

        // Close modal
        closeModalBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
          });
        });

        // Thumb click in modal
        modalThumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', () => {
            const mainImage = images[index];
            if (mainImage) {
              modalImage.src = mainImage.src;
              modalImage.alt = mainImage.alt;
            }
            modalThumbs.forEach((t, i) => {
              if (i === index) {
                t.classList.add('is-active');
                t.style.border = '14px solid #FFBD00';
                t.style.opacity = '1';
                t.style.borderRadius = '14px';
              } else {
                t.classList.remove('is-active');
                t.style.border = 'none';
                t.style.opacity = '0.5';
              }
            });
          });
        });

        // Dot navigation (optional: sync with scroll)
        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            // Update active dot
            dots.forEach((d) => d.classList.remove('is-active'));
            dot.classList.add('is-active');

            // Scroll to image
            const targetImage = images[index];
            if (targetImage) {
              targetImage.scrollIntoView({ behavior: 'smooth', inline: 'center' });
            }
          });
        });

        // Optional: Auto-update dots on scroll
        let isScrolling;
        slider.addEventListener('scroll', () => {
          clearTimeout(isScrolling);
          isScrolling = setTimeout(() => {
            const scrollLeft = slider.scrollLeft;
            const itemWidth = images[0].getBoundingClientRect().width + 9;
            const activeIndex = Math.round(scrollLeft / itemWidth);
            dots.forEach((dot, i) => {
              dot.classList.toggle('is-active', i === activeIndex);
            });
          }, 100);
        });
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const breadcrumbs = document.querySelector('.breadcrumbs');
    function updateBreadcrumbs() {
      breadcrumbs.style.display = window.innerWidth > 749
        ? 'flex'
        : 'none';
    }
    updateBreadcrumbs();
    window.addEventListener('resize', updateBreadcrumbs);
  });

  document.addEventListener("DOMContentLoaded", function() {
    const years = document.querySelectorAll(".timeline-year");
    const contents = document.querySelectorAll(".timeline-content");

    years.forEach(year => {
      year.addEventListener("click", () => {

// Remove active
        years.forEach(y => y.classList.remove("active"));
        contents.forEach(c => c.style.display = "none");

// Add active
        year.classList.add("active");
        document.querySelector(`#timeline-${
          year.dataset.year
        }`).style.display = "flex";
      });
    });

  // Set first year active
  if (years.length > 0) 
    years[0].classList.add("active");
  });

document.addEventListener("DOMContentLoaded", function() {
  const years = document.querySelectorAll(".timeline-year");
  const contents = document.querySelectorAll(".timeline-content");

  // Set first year (2025) as active
  if (years.length > 0 && contents.length > 0) {
    years[0].classList.add("active");
    contents[0].classList.add("active");
  }

  years.forEach((year, index) => {
    year.addEventListener("click", () => {
      // Remove active
      years.forEach(y => y.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      // Add active
      year.classList.add("active");
      contents[index].classList.add("active");
    });
  });
});


  } catch(e) { console.error(e); }
})();
})();
